<template>
  <div id="subjectprepare" class="mx-0">
    <br />
    <div align="center" :class="{  'h5': $vuetify.breakpoint.mdAndDown, 'h4': $vuetify.breakpoint.lgAndUp,  }">
      {{ $route.params.name != null ? $route.params.name + " - " + $route.params.topic : this.name + " - " + this.topic }}
    </div>
    <br />
    <v-container>
      <v-expansion-panels class="dark mx-0 my-2">
        <v-expansion-panel v-for="i in prepsubtopic" :key="i.quesid" class="mx-0 my-1 pa-0 py-0">

          <v-expansion-panel-header class="my-0 py-0 mx-0" style="outline: none;">
            <v-card flat class="py-0 my-0 mx-0">
              <v-card-title class="py-0 my-0 mx-0" :class="{  'caption': $vuetify.breakpoint.smAndDown,  'subtitle-2': $vuetify.breakpoint.mdAndUp,  }">
                {{i.subtopic}}
              </v-card-title>
            </v-card>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="mx-4 my-0" type="text" :class="{  'caption': $vuetify.breakpoint.smAndDown,  'body-2': $vuetify.breakpoint.mdAndUp,  }">
            <nl2br tag="p" :text="i.info" />
            <div v-if="i.img != undefined" class="center" align="center" justify="center">
              <v-row justify="center" class="my-0">
                <img v-bind:src="i.img" class="img-fluid" alt="Responsive image" />
              </v-row>
            </div>
          </v-expansion-panel-content>
          
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <br />
    <br />
  </div>
</template>

<script>
import db from "@/fb";

export default {
  data() {
    return {
      prepsubtopic: [],
      name: "",
      topic: "",
    };
  },
  computed: {},

  created() {
    var id = this.$route.params.id;
    var id2 = this.$route.params.id2;

    this.topic = this.$route.params.topic;

    var name = this.$route.params.name;
    console.log(id2);

    if (name == null) {
      //console.log('Null hai');
      let ref = db.collection("Subjects").doc(id);
      ref.get().then((snapshot) => {
        if (snapshot.exists) {
          var post = snapshot.data();
          this.name = post["Name"];

          let ref2 = db
            .collection("Subjects")
            .doc(id)
            .collection("Prepare")
            .doc(id2);
          ref2.get().then((snapshot) => {
            if (snapshot.exists) {
              var post = snapshot.data();
              this.topic = post["name"];
            } else {
              console.log("No such document!");
            }
          });
        } else {
          console.log("No such document!");
        }
      });
    }

    db.collection("Subjects")
      .doc(id)
      .collection("Prepare")
      .doc(id2)
      .collection("SubTopics")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            //topic: this.count += 1 ,

            subtopic: doc.data().name,
            //info: doc.data().info.replace(/(?:\r\n|\r|\n)/g, '<br/>'),
            info: doc.data().info,
            img: doc.data().image,
          };
          //console.log( data.img);
          console.log(doc.data().info.replace(/(?:\r\n|\r|\n)/g, "<br/>"));

          console.log(doc.data().info);
          this.prepsubtopic.push(data);
        });
      });
  },
  methods: {
    refresh() {
      var id = this.$route.params.id;
      this.prepsubtopic = [];
      this.count = 0;

      db.collection("Subjects")
        .doc(id)
        .collection("Prepare")
        .doc(id2)
        .collection("SubTopics")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              //topic: this.count += 1 ,
              subtopic: doc.data().name,

              //info: doc.data().info.replace(/(?:\r\n|\r|\n)/g, '<br/>'),
              info: doc.data().info,
              img: doc.data().image,
            };

            console.log(doc.data().info);
            console.log(doc.data().image);
            this.prepsubtopic.push(data);
          });
        });
    },
  },
};
</script>


<style>

.v-card-title {
  font-size: 3em;
}

</style>